import { render, staticRenderFns } from "./mobile_icons.vue?vue&type=template&id=470e72d5"
import script from "./mobile_icons.vue?vue&type=script&lang=js"
export * from "./mobile_icons.vue?vue&type=script&lang=js"
import style0 from "./mobile_icons.vue?vue&type=style&index=0&id=470e72d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports